import script from "./BaseSelectDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSelectDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSelectDropdown.vue?vue&type=style&index=0&id=1bce6a7f&lang=css"

const __exports__ = script;

export default __exports__